import { Button, Grid, makeStyles, Typography, useMediaQuery, useTheme } from "@material-ui/core";
import React from "react";
import { useIntl } from "react-intl";
import { BaseLayout, Header, ImageUploader } from "../components";
import { requestResetPassword, updateAvatarProfile } from "../ducks/actions";
import { ProfileForm } from "../features/profiles";
import { useActionRequest, useUserMe } from "../hooks";

const useStyles = makeStyles(theme => ({
  root: {
    "& > *": {
      marginBottom: theme.spacing(3)
    }
  }
}));

const ProfilePage = () => {
  const intl = useIntl();
  const classes = useStyles();

  const { user } = useUserMe();

  const updateAvatarProfileRequest = useActionRequest({
    action: updateAvatarProfile
  });

  const onAvatarUpload = ({ file }) => {
    updateAvatarProfileRequest({ avatar: file });
  };

  const requestResetPasswordRequest = useActionRequest({
    action: requestResetPassword,
    successMessage: intl.formatMessage({
      id: "Pages.ProfilePage.RequestResetPasswordSuccess",
      defaultMessage: "Reset password email sent"
    }),
    errorMessage: intl.formatMessage({
      id: "Pages.ProfilePage.RequestResetPasswordError",
      defaultMessage: "Reset password email not sent"
    })
  });

  const onRequestResetPassword = () => requestResetPasswordRequest({ email: user.email });

  const theme = useTheme();
  const isExtraSmall = useMediaQuery(theme.breakpoints.only("xs"));

  return (
    <BaseLayout className={classes.root}>
      <Header
        icon="innovation"
        title={intl.formatMessage({
          id: "Pages.ProfilePage.ManageAccount",
          defaultMessage: "Manage Account"
        })}
      />
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom>
            <strong>
              {intl.formatMessage({
                id: "Pages.ProfilePage.ProfilePicture",
                defaultMessage: "Profile picture"
              })}
            </strong>
          </Typography>
          <Grid container spacing={2} justify={isExtraSmall ? "center" : "flex-start"}>
            <Grid item>
              <ImageUploader
                imageUrl={user?.profile?.avatar}
                imageAlt={user?.profile?.lastName}
                onFileUpload={onAvatarUpload}
              />
            </Grid>
            <Grid item>
              <Typography>
                {intl.formatMessage({
                  id: "Pages.ProfilePage.AvatarHelper1",
                  defaultMessage: "Upload your photo..."
                })}
                <br />
                {intl.formatMessage({
                  id: "Pages.ProfilePage.AvatarHelper2",
                  defaultMessage: "Photo should be 300x300px and under 300kb size"
                })}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography variant="h6" gutterBottom>
            <strong>
              {intl.formatMessage({
                id: "Pages.ProfilePage.BasicInformations",
                defaultMessage: "Basic informations"
              })}
            </strong>
          </Typography>
          <ProfileForm profile={user?.profile} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography variant="h6" gutterBottom>
            <strong>
              {intl.formatMessage({
                id: "Pages.ProfilePage.ChangePassword",
                defaultMessage: "Change password"
              })}
            </strong>
          </Typography>
          <Typography gutterBottom>
            {intl.formatMessage({
              id: "Pages.ProfilePage.ResetPasswordHelper",
              defaultMessage:
                "Click on the button below to receive an email with the instruction to reset the password."
            })}
          </Typography>
          <Button variant="outlined" color="primary" size="large" onClick={onRequestResetPassword}>
            {intl.formatMessage({
              id: "Pages.ProfilePage.RequestChangePassword",
              defaultMessage: "Request change password"
            })}
          </Button>
        </Grid>
      </Grid>
    </BaseLayout>
  );
};

export default ProfilePage;
